var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCombo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_417_2243",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_417_2243",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAABPElEQVR4nO3dywqCUBRA0Yr+/5drFISDUqPrVtcaF0ib00HtcbkAAACMdd36AN48tj6AQT6+5rdRR8E8gsQIElPaIUc13Y12yJ4IEiNIzH3GY85yfvCy6V41ITGCxAgSM2eHTB3t3CW1I01IjCAxgsQIEiNIjCAxgsQIEiNIjCAxgsQIEiNIjCAxgsQIEiNIjCAxgsSsuaf+b4s+C3s0JiRGkBhBYgSJESRGkBhBYgSJESRGkBhBYkZcy/r1+xdLn7/ra18mJEaQGEFiRuyQpe/p7ofQIUiMIDGCxAgSI0iMIDGCxAgSI0iMIDHFz/ae6trVlAmJESRGkBhBYgSJESRGkBhBYgSJESRGkJjitayaob8Nb0JiBIkRJMYO+W7o/RkTEiNIjCAxa3ZI6j+bjsaExAgSIwgAAMDJPQEteAq50MKcSgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombo);
export default __webpack_public_path__ + "static/media/combo.29f73e79e2ccab29da7a2a98807416e7.svg";
export { ForwardRef as ReactComponent };